import { decodeBearerToken } from '../cookies'
import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

export function splitMobileRecords(data: string): string[] {
  return data
    .trim()
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0)
}

export function canParseMobile(data: string): boolean {
  for (const raw of data.trim().split('\n')) {
    const line = raw.trim()
    if (!line) continue
    const parts = line.split('|')
    if (parts.length >= 4 && (parts[3].includes('Bearer') || parts[3].includes('Authorization'))) {
      return true
    }
  }
  return false
}

export function parseMobile(record: string): AccountData {
  const parts = record.trim().split('|')
  if (parts.length < 4) {
    throw new ParseError(`Expected at least 4 pipe-separated parts, got ${parts.length}`)
  }

  const loginPass2fa = parts[0]
  const mobileUa = parts[1] ?? ''
  const androidId = parts[2] ?? ''
  const mobileHeaders = parts[3] ?? ''
  const proxy = parts[4] ?? ''
  const emailPass = parts[5] ?? ''

  const lp = loginPass2fa.split(':')
  if (lp.length < 2) throw new ParseError(`Cannot parse login:pass from: ${loginPass2fa}`)
  const login = lp[0]
  const password = lp[1]
  const twofaKey = lp[2] ?? ''

  const cookies: Record<string, string> = {}
  let bearerToken = ''

  for (const headerRaw of mobileHeaders.split(';')) {
    const eq = headerRaw.indexOf('=')
    if (eq <= 0) continue
    const key = headerRaw.slice(0, eq).trim()
    const value = headerRaw.slice(eq + 1).trim()
    cookies[key] = value
    if (key === 'Authorization') {
      bearerToken = value.replace('Bearer ', '')
    }
  }

  if (bearerToken) {
    try {
      const tokenData = decodeBearerToken(bearerToken)
      if (typeof tokenData.sessionid === 'string') cookies.sessionid = tokenData.sessionid
      if (typeof tokenData.ds_user_id === 'string') cookies.ds_user_id = tokenData.ds_user_id
    } catch {
      // ignore — Python silently swallows decode errors
    }
  }

  let emailLogin = ''
  let emailPassword = ''
  if (emailPass.includes(':')) {
    const idx = emailPass.indexOf(':')
    emailLogin = emailPass.slice(0, idx)
    emailPassword = emailPass.slice(idx + 1)
  }

  return {
    ...emptyAccount(),
    login,
    password,
    twofaKey,
    cookies,
    userAgent: mobileUa,
    proxy,
    emailLogin,
    emailPassword,
    androidId,
  }
}
